import { useNavigate } from "react-router-dom";
import React, { useEffect } from "react";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import { useFocusable } from "@noriginmedia/norigin-spatial-navigation";
import { ButtonBase } from "@mui/material";

const BackBarButton = ({ invertedIcon }) => {
  const navigate = useNavigate();

  const { focused, ref } = useFocusable({
    focusKey: "backBarButton",
    onEnterPress: () => navigate(-1),
  });

  useEffect(() => {
    if (focused) {
      ref?.current?.dispatchEvent(
        new MouseEvent("mouseover", {
          view: window,
          bubbles: true,
          cancelable: true,
        })
      );
    }
  }, [focused]);

  return (
    <ButtonBase
      className="dark !bg-black/50 !backdrop-blur-xl !border-1 !border-zinc-700 !rounded-2xl !text-white !m-5"
      onClick={() => navigate(-1)}
      ref={ref}
      style={{
        boxShadow: focused
          ? "inset 0 0 0 4px #F5F5F5"
          : "inset 0 0 0 4px transparent",
        fontSize: 25,
        padding: "1.5rem 2rem",
      }}
    >
      {invertedIcon ? (
        <ArrowForwardIosRoundedIcon
          fontSize="lg"
          sx={{
            transform: "scaleX(-1)",
          }}
        />
      ) : (
        <ArrowForwardIosRoundedIcon fontSize="lg" />
      )}
      بازگشت
    </ButtonBase>
  );
};

export const BackBarButtonMini = ({ invertedIcon }) => {
  const navigate = useNavigate();

  const { focused, ref } = useFocusable({
    focusKey: "backBarButton-mini",
    onEnterPress: () => navigate(-1),
  });

  useEffect(() => {
    if (focused) {
      ref?.current?.dispatchEvent(
        new MouseEvent("mouseover", {
          view: window,
          bubbles: true,
          cancelable: true,
        })
      );
    }
  }, [focused]);

  return (
    <button
      className="h-16 w-16 bg-[#121212] rounded-xl"
      onClick={() => navigate(-1)}
      ref={ref}
      style={{
        backgroundColor: focused ? "dimgray" : "",
        boxShadow: focused ? "inset 0 0 0 4px #F5F5F5" : "inset 0 0 0 4px transparent",
        fontSize: 30,
      }}
    >
      {invertedIcon ? (
        <ArrowForwardIosRoundedIcon
          fontSize="lg"
          htmlColor="whitesmoke"
          sx={{
            transform: "scaleX(-1)",
          }}
        />
      ) : (
        <ArrowForwardIosRoundedIcon htmlColor="whitesmoke" fontSize="lg" />
      )}
    </button>
  );
};

export default BackBarButton;
